import type {components, paths} from '../../openapi';
import {axiosInstance} from '../axiosInstance';

export type Vacancy = components['schemas']['Vacancy'];
export type Vacancies = components['schemas']['Vacancies'];

export type FetchVacanciesQuery = NonNullable<paths['/executor_web/vacancies']['get']['parameters']['query']> & {
	page?: number;
	per_page?: number;
};

/** GET `/api/executor_web/v1/executor_web/vacancies` — см. `paths['/executor_web/vacancies']` в openapi */
export function fetchVacancies(query?: FetchVacanciesQuery, signal?: AbortSignal) {
	return axiosInstance.get<Vacancies>('vacancies', {params: query, signal});
}
